<template>
  <el-row :gutter="10">
    <el-col :span="24">
      <el-card :shadow="handle.shadow ? 'always' : 'never'" :class="handle.noBorder && 'no-border'">
        <slot name="top-title" />
        <el-table
          ref="formTable"
          stripe
          fit
          size="mini"
          style="width: 100%"
          v-loading="handle.loading"
          :span-method="handle && handle.spanMethod"
          :height="handle.tableHeight || undefined"
          :data="data"
          :row-key="handle.rowKey"
          :show-header="handle.showHeader"
          :border="handle.tableBorder"
          highlight-current-row
          @select-all="handleSelectionChange"
          @select="handleSelectionChange"
        >

          <template v-for="(item,index) in getConfigList()">
            <el-table-column
              v-if="item.type == 'index'"
              :key="index"
              :prop="item.prop"
              :label="$t(item.label)"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            />
            <!-- 单选框 -->
            <el-table-column
              v-if="item.type === 'selection'"
              :key="index"
              :reserve-selection="handle.reserveSelection"
              type="selection"
              width="55"
              :fixed="item.fixed"
            />
            <!-- 普通输入框 -->
            <el-table-column
              v-else-if="item.type === 'input'"
              :key="index"
              :prop="item.prop"
              :disabled="item.disabled"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="data[scope.$index][item.prop]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled || scope.row.disabled"
                  @change="handleEvent(item.event, scope)"
                />
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item.type === 'input_focus'"
              :key="index"
              :prop="item.prop"
              :disabled="item.disabled"
              :readOnly="item.readOnly"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="data[scope.$index][item.prop]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled || scope.row.disabled"
                  :readOnly="item.readOnly || scope.row.readOnly"
                  @blur="handleEvent(item.event, scope,scope.$index)"
                />
              </template>
            </el-table-column>
            <!-- 数字输入框 -->
            <el-table-column
              v-else-if="item.type === 'number'"
              :key="index"
              :prop="item.prop"
              :disabled="item.disabled"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="data[scope.$index][item.prop]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  :min="scope.row.min || 0"
                  :max="scope.row.max"
                  :precision="item.precision || 0"
                  @change="handleEvent(item.event, scope)"
                  controls-position="right"
                />
              </template>
            </el-table-column>
            <!-- 选择框 -->
            <el-table-column
              v-else-if="item.type === 'select' && item.show !== false"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :type="item.type"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="item.type === 'select'"
                  v-model="data[scope.$index][item.prop]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled || data[scope.$index][`${item.prop}_disabled`]"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :filterable="item.filterable"
                  remote
                  :remote-method="(query) => remoteMethod(item, query)"
                  :loading="item.loading || false"
                  :placeholder="getPlaceholder(item)"
                  @change="handleEvent(item.event, scope)"
                >
                  <el-option
                    v-for="(childItem, childIndex) in (data[scope.$index][`${item.prop}_list`] || listTypeInfo[item.list])"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
                <el-tooltip
                  v-if="item.tipEvent && !item.disabled"
                  class="item"
                  :content="item.content"
                  placement="bottom-start"
                >
                  <el-button type="text" @click="handleClick(item.tipEvent)">
                    <i class="el-icon-circle-plus" />
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 选择器 -->
            <el-table-column
              v-else-if="item.type === 'picker'"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              show-overflow-tooltip
            >
              <!-- 日期、时间选择器 -->
              <template slot-scope="scope">
                <el-col v-if="item.date" :span="11">
                  <el-date-picker
                    v-model="data[scope.$index][item.date.value]"
                    type="date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="getPlaceholder(item)"
                    :disabled="item.disabled"
                    style="width: 100%;"
                  />
                </el-col>
                <el-col v-else-if="item.startTime" :span="11">
                  <el-time-picker
                    v-model="data[scope.$index][item.startTime.value]"
                    :placeholder="getPlaceholder(item)"
                    :disabled="item.disabled"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 100%;"
                  />
                </el-col>
                <el-col
                  v-if="(item.date || item.startTime) && item.time"
                  class="line text-center"
                  :span="1"
                >-</el-col>
                <el-col v-if="item.time" :span="11">
                  <el-time-select
                    v-if="item.time.type === 'timeSelect'"
                    v-model="data[scope.$index][item.time.value]"
                    :picker-options="{ start: '00:30', step: '00:30', end: '24:00' }"
                    :disabled="item.disabled"
                    :placeholder="getPlaceholder(item)"
                  />
                  <el-time-picker
                    v-else
                    v-model="data[scope.$index][item.time.value]"
                    :placeholder="getPlaceholder(item)"
                    :disabled="item.disabled"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 100%;"
                  />
                </el-col>
              </template>
            </el-table-column>
            <!-- 删除按钮 -->
            <el-table-column
              v-else-if="item.type === 'delete' && item.show !== false"
              :key="index"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  :disabled="item.disabled"
                  @click="handleClick(item.event, scope.$index)"
                />
              </template>
            </el-table-column>
            <!-- 图标按钮 -->
            <el-table-column
              v-else-if="item.type == 'actions'"
              :key="index"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <template v-for="(bt,i) in handle.btList">
                  <el-tooltip :key="i" class="item" :content="bt.label" placement="bottom-start">
                    <el-button
                      plain
                      size="mini"
                      :type="bt.type"
                      :icon="bt.icon"
                      circle
                      @click="handleClick(bt.event, scope.row)"
                    >
                      <svg-icon v-if="bt.iconClass" :icon-class="bt.iconClass" />
                    </el-button>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <!-- 增加\删除行按钮 -->
            <el-table-column
              v-else-if="item.type === 'line' && item.show !== false"
              :key="index"
              align="right"
              :width="item.width"
            >
              <template slot="header" slot-scope="scope">
                <el-button
                  type="info"
                  class="el-icon-plus"
                  size="mini"
                  :disabled="item.disabled"
                  @click="handleClick(item.addEvent, scope)"
                />
              </template>
              <template slot-scope="scope">
                <el-button
                  v-if="table.data.length > 0"
                  size="mini"
                  type="danger"
                  class="el-icon-minus"
                  :disabled="item.disabled"
                  @click="handleClick(item.removeEvent, scope.$index)"
                />
              </template>
            </el-table-column>
            <!-- 联级选择器 -->
            <el-table-column
              v-else-if="item.type === 'cascader'"
              :key="index"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <el-cascader
                  v-model="data[scope.$index][item.prop]"
                  :options="listTypeInfo[item.list]"
                  :props="{ expandTrigger: 'hover' }"
                  tyle="width:100%"
                  :disabled="item.disabled"
                ></el-cascader>
              </template>
            </el-table-column>
            <!-- 普通文本 -->
            <el-table-column
              v-else-if="item.type === 'text'"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :type="item.type"
              show-overflow-tooltip
              :width="item.width"
              :fixed="item.fixed"
            />
            <!-- 自定义列 -->
            <el-table-column
              v-else-if="item.type === 'custom'"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :type="item.type"
              show-overflow-tooltip
              :width="item.width"
            >
              <template slot-scope="scope">
                <slot name="custom-column" :scope="scope" />
              </template>
            </el-table-column>
          </template>
        </el-table>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    // 列表数据
    data: {
      type: Array,
    },
    // 相关字段
    fieldList: {
      type: Array,
    },
    // 额外配置
    handle: {
      type: Object,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    // 相关的列表
    listTypeInfo: {
      type: Object,
    },
    refObj: {
      type: Object,
    },
  },
  watch: {
    data: {
      handler: function (val) {
        // 将实例返回到父级
        this.$emit("update:refObj", this.$refs.formTable);
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    // 将实例返回到父级
    this.$emit("update:refObj", this.$refs.formTable);
  },
  methods: {
    getConfigList() {
      return (this.fieldList || []).filter(
        (item) =>
          !item.hasOwnProperty("show") ||
          (item.hasOwnProperty("show") && item.show)
      );
    },
    // 得到placeholder的显示
    getPlaceholder(row) {
      let placeholder;
      if (row.type === "input" || row.type === "textarea") {
        placeholder = "请输入" + row.label;
      } else if (
        row.type === "select" ||
        row.type === "time" ||
        row.type === "date" ||
        row.type === "picker"
      ) {
        placeholder = "请选择" + row.label;
      } else if (row.type === "number") {
        placeholder = "请输入数字";
      } else {
        placeholder = row.label;
      }
      return placeholder;
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    // 选中数据
    handleSelectionChange(value) {
      this.$emit("handleEvent", this.handle.selection, value);
    },
    //select框远程搜索
    remoteMethod(item, query) {
      item.loading = false;
      this.handleEvent(item.remoteMethod, query);
    },
  },
};
</script>
<style>
.no-border {
  border: 0;
}

.el-card.no-border .el-card__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog-table.vue